/* Joy: share the live configuration from the Redeem inline app embed.
 * Same vendor URL and async insertion as Joy's avada-joy.js bootstrap.
 * If the native app embed is enabled again, do not load the widget twice.
 */
(function () {
  if (!window.AVADA_JOY || document.querySelector('script[src^="https://static.joy.so/avada-joy.min.js"]')) return;
  const scriptElement = document.createElement('script');
  scriptElement.type = 'text/javascript';
  scriptElement.async = true;
  scriptElement.src = `https://static.joy.so/avada-joy.min.js?v=${new Date().getTime()}`;
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(scriptElement, firstScript);
})();
